import LoadingPage from 'components/LoadingPage';
import { Alert, Button, Stack } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useStore } from 'store';
import { EAuthStage } from 'store/AuthStore';

const withAuthentication = <P extends Record<string, any>>(
  Component: React.ComponentType<P>
): FC<P> =>
  observer((props) => {
    const { AuthStore: auth } = useStore();
    const router = useRouter();
    useEffect(() => {
      auth.initialize();
    }, [auth]);
    useEffect(() => {
      if (
        auth.initialized &&
        ![EAuthStage.AUTHENTICATED, EAuthStage.INITIALIZING, EAuthStage.SERVICE_ERROR].includes(
          auth.authStage
        )
      ) {
        router.replace('/auth/login');
      }
    }, [auth.initialized, auth.authStage, router]);
    if (auth.authStage === EAuthStage.SERVICE_ERROR)
      return (
        <Stack spacing={2} p={3}>
          <Alert severity="error">{auth.errors.initialize}</Alert>
          <Button onClick={() => auth.initialize(true)}>Retry</Button>
        </Stack>
      );
    if (auth.authStage !== EAuthStage.AUTHENTICATED) return <LoadingPage fullPage />;
    return (
      <>
        {auth.errors.refresh && <Alert severity="warning">{auth.errors.refresh}</Alert>}
        {auth.errors.logout && (
          <Alert
            severity="error"
            action={
              <Button onClick={() => auth.logout(auth.logoutAllRequested)}>Retry sign out</Button>
            }
          >
            {auth.errors.logout}
          </Alert>
        )}
        <Component {...props} />
      </>
    );
  });
export default withAuthentication;
